import {
  GetSimulationBuildingListRes,
  GetSimulationBuildingListReq
} from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

/** 山積対象物件一覧-明細部取得 */
export class SimulationBuildingListGateway {
  static getSimulationBuildingList = async (
    params: GetSimulationBuildingListReq
  ) => {
    return await yamadumiApi.get<GetSimulationBuildingListRes>('/api/simulation/building/list', { ...params })
  }
}
